// extracted by mini-css-extract-plugin
export default {"error-boundary":"error-boundary","errorBoundary":"error-boundary","event-id":"event-id","eventId":"event-id"};